import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=a9fbfdb8"
import script from "./SupplierInfo.vue?vue&type=script&lang=js"
export * from "./SupplierInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports